module.exports = __webpack_public_path__ + "img/climate-control-black.0fc78fa.svg";